import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;

class DashboardRequests {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem(
          "txtconnect_ng_admin_token"
        )}`,
      },
    };
  }

  async getDashboardStats() {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin_stats`,
        this.getHeaders()
      );
      return {
        success: true,
        message: "Dashboard stats fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: "Error fetching dashboard stats",
        error: error.response?.data?.message || "An error occurred",
      };
    }
  }

  // from/to are plain "YYYY-MM-DD" strings. Response envelope matches
  // admin_stats exactly (status_code/data at the same nesting depth), so the
  // unwrap convention here is identical: data is response.data.data, and the
  // caller reads data.status_code / data.data.total_sms_sent from there.
  async getSmsUsageCount(from, to) {
    try {
      const response = await axios.get(
        `${BASE_URL}/sms-usage/count?from=${from}&to=${to}`,
        this.getHeaders()
      );
      return {
        success: true,
        message: "SMS usage count fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: "Error fetching SMS usage count",
        error: error.response?.data?.message || "An error occurred",
      };
    }
  }
}
const dashboardRequests = new DashboardRequests();
export default dashboardRequests;
